import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.css'],
  // providers: [EventFetcherService]
})

export class BarChartComponent {


  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true
  };

  @Input() public barChartLabels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
  // public barChartLabels = [];

  public barChartType = 'bar';
  public barChartLegend = true;

  @Input() public barChartData: any[] = [
    {data: [65, 59, 80, 81, 56, -55, 40], label: 'Female'},
    {data: [-28, 48, 40, -19, 86, -27, 90], label: 'Male'}
  ];

  // public barChartData: any[] = [];

  constructor() {}

  // events
  /*
  public chartClicked(e: any): void {
    console.log(e);
  }
  public chartHovered(e: any): void {
    console.log(e);
  }
*/

}



// WEBPACK FOOTER //
// ./src/app/report/charts/bar-chart/bar-chart.component.ts